import React, { useEffect } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { fetchBalanceSummary } from "../../../redux/slices/timeBalanceSlice";
import HoursHeader from "../HoursHeader/HoursHeader";

const BalanceDashboard = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const { balanceSummary, isSummaryLoading } = useSelector(state => state.timeBalances);
  const currentUser = useSelector(state => state.auth.user);

  useEffect(() => {
    if (currentUser?.id) {
      dispatch(fetchBalanceSummary(currentUser.id));
    }
  }, [currentUser?.id, dispatch]);

  const currentMonthMinutes = balanceSummary?.current_month_minutes || 0;
  const accumulatedApprovedMinutes = balanceSummary?.accumulated_approved_minutes || 0;

  const formatMinutes = (totalMinutes) => {
    const val = totalMinutes || 0;
    const minutes = Math.abs(val);
    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hrs}h ${mins.toString().padStart(2, '0')}m`;
  };

  const now = new Date();
  const formattedDate = now.toLocaleDateString(i18n.language, { 
    day: 'numeric', 
    month: 'long', 
    year: 'numeric' 
  });

  if (isSummaryLoading) {
    return (
      <div className="atlar-card p-4 w-100 d-flex justify-content-center align-items-center" style={{ minHeight: "180px" }}>
        <Spinner animation="border" style={{ color: 'var(--brand-primary)' }} size="sm" />
      </div>
    );
  }

  const isPositive = currentMonthMinutes >= 0;

  return (
    <div className="atlar-card p-4 w-100 h-100 d-flex flex-column justify-content-between" style={{ minHeight: "180px" }}>
      <div>
        <Row className="mb-2">
          <Col>
            <HoursHeader />
          </Col>
        </Row>
        
        <Row className="mb-3">
          <Col>
            <p className="txt-subtle m-0 fw-semibold" style={{ fontSize: "0.85rem" }}>
              {t('components.BalanceDashboard.date_range', { 
                start: t('components.BalanceDashboard.january'), 
                year: now.getFullYear(), 
                end: formattedDate 
              })}
            </p>
          </Col>
        </Row>
      </div>

      <div 
        className="my-3 py-3 border-top border-bottom d-flex justify-content-between align-items-center"
        style={{ borderColor: 'var(--gray-200)' }}
      >
        <span className="txt-subtle fw-semibold" style={{ fontSize: "0.85rem" }}>
          {t('components.BalanceDashboard.accumulated_bank')}:
        </span>
        <span className="fw-bold txt-main" style={{ fontSize: "0.95rem" }}>
          {accumulatedApprovedMinutes >= 0 ? "+ " : "- "}
          {formatMinutes(accumulatedApprovedMinutes)}
        </span>
      </div>

      <Row>
        <Col>
          <small 
            className="d-block txt-subtle text-uppercase fw-bold mb-1" 
            style={{ fontSize: "0.7rem", letterSpacing: "0.5px" }}
          >
            {t('components.BalanceDashboard.current_period_balance')}
          </small>
          
          <span 
            className={`fw-bold ${isPositive ? "txt-success" : "txt-danger"}`} 
            style={{ fontSize: "2rem", lineHeight: "1.2" }}
          >
            {isPositive ? "+ " : "- "}
            {formatMinutes(currentMonthMinutes)}
          </span>
        </Col>
      </Row>
    </div>
  );
};

export default BalanceDashboard;